import { useCloseNavSearch, useNavSearch } from "@hooks/use-nav-search-hooks";
import NavSearchContainer from "@components/layout/Navbar/NavSearchContainer";
import AlgoliaSearchBar from "@components/layout/Navbar/AlgoliaSearchBar/AlgoliaSearchBar";
import Offcanvas from "@components/core/Offcanvas";

function NavSearch() {
  const navSearchIsOpen = useNavSearch();
  const closeNavSearch = useCloseNavSearch();

  return (
    <Offcanvas
      show={navSearchIsOpen}
      onHide={closeNavSearch}
      placement="start"
    >
      <div className="bg-white p-3 border-bottom border-lighter-gray">
        <AlgoliaSearchBar />
      </div>

      <NavSearchContainer />

      <div
        style={{ flex: 1 }}
        className="bg-lighter-gray"
      />
    </Offcanvas>
  );
}

export default NavSearch;
